import "./metricWidget.scss";
import { ComponentRegistry } from '@ts/utils/ComponentRegistry';

const METRIC_WIDGET_SELECTOR = '.metric-widget';

import { icon, IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faMoneyBillTrendUp, faTrophy, faHeart, faUser, faUsers, faSquare } from "@fortawesome/free-solid-svg-icons";

const ICONS: Record<string, IconDefinition> = {
  sales: faMoneyBillTrendUp,
  goal: faTrophy,
  earnings: faHeart,
  participants: faUser,
  supporters: faUsers,
  default: faSquare
};

export class MetricWidget {
    private readonly metricType: string;
    private readonly metricIcon: IconDefinition;
    private readonly metricLabel: string;
    private readonly metricValue: string;
    private readonly id: string;
    private static registry = new ComponentRegistry<MetricWidget>('metric-widget');

    private constructor(private readonly element: HTMLElement) {
        // Guard clause - validate element
        if (!(element instanceof HTMLElement)) {
            throw new Error('MetricWidget: Element must be an HTMLElement');
        }
        this.id = MetricWidget.registry.register(element, this);
        this.metricType = element.dataset.metricType ?? 'default';
        this.metricLabel = element.dataset.metricLabel ?? '';
        this.metricValue = element.dataset.metricValue ?? '';
        this.metricIcon = ICONS[this.metricType] ?? ICONS.default;
        
        
        this.createMetric();
    }

    private createMetric(): void {
        const rendered = icon(this.metricIcon).html[0] || '';
        
        this.element.classList.add(this.metricType);
        this.element.innerHTML = `
            <div class="metric-icon">
                ${rendered}
            </div> 
            <div class="metric-content">
                <div class="metric-label">${this.metricLabel}</div>
                <div class="metric-value">${this.metricValue}</div>
            </div>
        `;
    }

    // Factory Method

    public static create(
        target: string | HTMLElement | NodeListOf<HTMLElement> | HTMLElement[] = METRIC_WIDGET_SELECTOR
    ): MetricWidget[] | null {
        const elements = ComponentRegistry.processTargets<MetricWidget, HTMLElement>(
            MetricWidget.registry,
            target,
            [HTMLElement]);

        if (!elements.length) return null;
        
        return elements
            .map(el => new MetricWidget(el));
    }

    public static getMetric(id: string): MetricWidget | null {
        return MetricWidget.registry.get(id) ?? null;
    }
    
    public destroy(): void {
        MetricWidget.registry.unregister(this.id);
    }
}